import backendFetch from '../../api/backendFetch';

/**
 * Using mutation to send it as payload object
 * @param {{
 *  uuid: string,
 * }} payload
 */
const deleteDatasetFn = async (payload) => {
  const { uuid } = payload;
  const {
    account: { name: organizationName, id: organizationId },
    project: { id: projectId },
  } = window.VSS.getWebContext();

  await backendFetch(`/actionable-agile/api/datasets/${uuid}`, {
    method: 'DELETE',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-org-name': organizationName,
      'x-55d-project-id': projectId,
    },
    bodyOptions: {
      allowEmpty: true,
    },
    body: {},
  });
};

export default deleteDatasetFn;
